<template>
  <div
    id="footer"
    class="absolute bottom-0 right-0 flex w-full flex-row flex-nowrap items-center justify-end gap-[27px] bg-onelaunch_ui_shades_50 pr-[10px] text-right font-roboto text-[13px] leading-10 dark:bg-radio_group_bg_color"
  >
    <ClassicNtpCommonSettings v-if="showSettings" data-testid="settings" />
    <a
      class="text-footer_color visited:no-underline hover:text-footer_color hover:underline dark:text-dark_mode_grey dark:hover:text-dark_mode_grey"
      href="/contact"
      target="_blank"
    >
      {{ $t('contact_us') }}
    </a>
    <a
      class="text-footer_color visited:no-underline hover:text-footer_color hover:underline dark:text-dark_mode_grey dark:hover:text-dark_mode_grey"
      href="/partnerships"
      target="_blank"
    >
      {{ $t('advertise') }}
    </a>
    <a
      class="text-footer_color visited:no-underline hover:text-footer_color hover:underline dark:text-dark_mode_grey dark:hover:text-dark_mode_grey"
      href="/privacy-policy"
      target="_blank"
    >
      {{ $t('privacy_policy') }}
    </a>
    <a
      class="text-footer_color visited:no-underline hover:text-footer_color hover:underline dark:text-dark_mode_grey dark:hover:text-dark_mode_grey"
      href="/terms"
      target="_blank"
    >
      {{ $t('terms_of_use') }}
    </a>
    <span class="text-footer_color dark:text-dark_mode_grey">© {{ year }} OneNews</span>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    showSettings?: boolean
  }

  withDefaults(defineProps<Props>(), { showSettings: true })

  const year = new Date().getFullYear()
</script>
